import { render, staticRenderFns } from "./PatientDoseSpot.vue?vue&type=template&id=6811b661&"
import script from "./PatientDoseSpot.vue?vue&type=script&lang=js&"
export * from "./PatientDoseSpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports